module.exports = __webpack_public_path__ + "static/media/default-image.edb75fdf.png";